import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    Legend,
    BarController,
} from 'chart.js';

import { useMemo } from 'react';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    Legend,
);

export default function MixedBarLines ({ data, options, plugins }) {
    const { datasets, labels } = data;

    const chartData = useMemo(() => ({
        labels: labels,
        datasets: datasets,

    }), [datasets, labels]);

    return (
        <Chart type='bar' data={chartData} options={options} plugins={plugins} />
    )
}
